import type { ReactNode } from 'react';

export type ToniAvviso = 'errore' | 'attenzione' | 'informativo';

interface Props {
  tono: ToniAvviso;
  titolo: ReactNode;
  children?: ReactNode;
}

const SEGNO: Record<ToniAvviso, string> = {
  errore: '!',
  attenzione: '!',
  informativo: 'i',
};

/**
 * Riquadro di avviso, tre toni. Il filetto sinistro spesso 4 px è ciò che lo distingue da
 * una scheda: si legge come annotazione a margine del registro.
 */
export function Avviso({ tono, titolo, children }: Props) {
  return (
    <div className={`avviso avviso--${tono}`} role={tono === 'errore' ? 'alert' : 'status'}>
      <div className="avviso__segno" aria-hidden="true">
        {SEGNO[tono]}
      </div>
      <div>
        <div className="avviso__titolo">{titolo}</div>
        {children ? <div className="avviso__testo">{children}</div> : null}
      </div>
    </div>
  );
}
